/**
 * User API
 */
import { post, put, get, delete as _delete } from "axios";


export default {
    /**
     * Save New Password
     * Authorization Doesn't Required
     */
    saveNewPassword(params) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}user/password`,
                config = {
                            headers: {
                                token: process.env.UNIQUE_TOKEN,
                            }
                        };

            put(url, params, config)
                .then((res) => {
                    resolve(res)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },


    /**
     * 
     * User Sign Up
     * Authorization Deosn't Required
     */
    signup(user) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}user/register`,
                config = {
                            headers: {
                                token: process.env.UNIQUE_TOKEN,
                            }
                        };

            post(url, user, config)
                .then((response) => {
                    resolve(response)
                })
                .catch( (error) => {
                    reject(error)
                })
        })
    },



    /**
     * Delete User
     */
    deleteUser(params, token) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}user`,
                config = {
                    data: params,
                    headers: {
                        auth_token: token
                    }
                };

                _delete(url, config)
                    .then((res) => {
                        if (res.status === 200) {
                            resolve(res.data)
                        } else {
                            reject(res.data)
                        }
                    }).catch((error) => {
                        reject(error.response)
                    })
        })
    },



    /**
     * Update User Meta Attributes
     */
    updateUserMeta(params, token) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}user/meta`,
                config = {
                    headers: {
                        auth_token: token
                    }
                };

            put(url, params, config)
                .then((res) => {
                    resolve(res)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    

    /**
     * Update User Meta Attributes
     */
    getUserMeta(token) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}user/meta`,
                config = {
                    headers: {
                        auth_token: token,
                    }
                };

            get(url, config)
                .then((res) => {
                    return resolve(res)
                }).catch((error) => {
                    return reject(error)
                })
        })
    },


    /**
     * get Nationality Master
     * Authorization Does Not Required, Extra Params also not required
     */
    getNationality() {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}user/nationality`;
            
            get(url)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/user.js